function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "Capa_1",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 401.352 401.352",
  style: {
    "enableBackground": "new 0 0 401.352 401.352"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFD7A3"
  },
  d: "M128.383,241.645c14.716-9.475,13.07-37.675,13.07-44.255h118.446c0,6.58-1.825,34.78,12.89,44.255 l-72.113,80.771L128.383,241.645z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FDC88E"
  },
  d: "M246.738,269.774l26.051-28.129c-14.716-9.474-12.89-37.675-12.89-44.255H141.453 C149.951,221.822,206.16,263.742,246.738,269.774z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M292.8,111.846c0,52.696-30.343,118.446-92.124,118.446s-92.124-65.75-92.124-118.446 S127.097,5.71,200.676,5.71S292.8,59.15,292.8,111.846z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M111.717,125.007c-9.864-2.468-16.326,2.805-16.326,13.161c0,13.709,13.265,47.296,27.21,26.321 S111.717,125.007,111.717,125.007z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#FFE1B2"
  },
  d: "M288.14,125.007c10.767-2.468,17.821,2.805,17.821,13.161c0,13.709-14.479,47.296-29.701,26.321 S288.14,125.007,288.14,125.007z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#A0756F"
  },
  d: "M107.911,135.671c-4.935-18.918-12.484-84.348,2.468-103.366 c19.831-25.225,35.647-8.458,35.647-8.458l3.835,43.964l-30.16,72.521L107.911,135.671z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#A0756F"
  },
  d: "M231.909,3.481c-50.952-10.82-88.667,6.303-99.403,14.395c-1.006,0.758-1.776,1.437-2.297,2.007 l19.651,47.241c47.296,23.668,95.826,25.329,95.826,25.329l5.972-28.896l30.425,75.884l11.29-3.804c0,0,5.367-54.81,6.19-67.681 S287.636,15.315,231.909,3.481z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#4EA0CA"
  },
  d: "M352.023,401.352c10.903,0,19.741-8.838,19.741-19.741v-64.14 c0-28.954-22.562-59.864-50.138-68.687l-57.652-18.492c-22.149,16.936-37.317,34.107-63.298,34.107s-41.308-17.171-63.457-34.107 l-57.494,18.492c-27.576,8.823-50.138,39.733-50.138,68.687v64.14c0,10.903,8.838,19.741,19.741,19.741H352.023z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#2D91C0"
  },
  d: "M321.626,248.784l-57.652-18.492c-22.149,16.936-37.317,34.107-63.298,34.107 s-41.308-17.171-63.457-34.107l-57.493,18.492c-27.576,8.823-50.138,39.733-50.138,68.687v9.853h342.177v-9.853 C371.764,288.516,349.202,257.607,321.626,248.784z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#29394A"
  },
  d: "M108.129,233.545l-28.985,10.564c-2.598,0.947-4.327,3.417-4.327,6.183v151.06h39.496V237.873 C114.313,234.675,111.134,232.45,108.129,233.545z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#29394A"
  },
  d: "M297.918,116.775c0.219-1.211-0.712-2.326-1.943-2.326h-36.224h-0.19h-45.999h-0.012h-25.929 h-46.013h-0.187h-36.227c-1.231,0-2.162,1.114-1.943,2.326l1.422,7.856l26.877,13.139v18.899c0,5.451,4.419,9.87,9.87,9.87h26.999 c4.625,0,10.403-3.216,12.84-7.146l12.271-19.786c0.218-0.352,0.427-0.743,0.643-1.112c0,0.018,0.003,0.037,0.003,0.055h12.854 c0.206,0.35,0.404,0.723,0.612,1.057l12.271,19.785c2.438,3.931,8.217,7.147,12.842,7.147h26.996c5.451,0,9.87-4.419,9.87-9.87 v-18.9l26.874-13.138L297.918,116.775z M190.911,128.022c0,2.924-1.43,5.629-2.972,8.116l-12.274,19.792 c-1.305,2.108-4.762,4.029-7.249,4.029h-26.996c-1.815,0-3.29-1.478-3.29-3.29V124.32c0-1.812,1.475-3.29,3.29-3.29h46.2 c1.815,0,3.29,1.478,3.29,3.29V128.022z M263.041,156.669c0,1.812-1.475,3.29-3.29,3.29h-26.996c-2.487,0-5.944-1.921-7.252-4.036 l-12.271-19.786c-1.542-2.487-2.972-5.192-2.972-8.116v-3.701c0-1.812,1.475-3.29,3.29-3.29h46.2c1.815,0,3.29,1.478,3.29,3.29 V156.669z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D0D7DC"
  },
  d: "M206.719,172.455h-12.262c-4.207,0-7.333-3.893-6.425-8l4.845-26.322 c0.754-3.664,3.98-6.293,7.721-6.293h0c3.744,0,6.971,2.633,7.723,6.3l4.824,26.321 C214.049,168.566,210.923,172.455,206.719,172.455z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#E4EBF0"
  },
  d: "M190.911,128.022c0,2.924-1.43,5.629-2.972,8.116l-12.274,19.792 c-1.305,2.108-4.762,4.029-7.249,4.029h-26.996c-1.815,0-3.29-1.478-3.29-3.29V124.32c0-1.812,1.475-3.29,3.29-3.29h46.2 c1.815,0,3.29,1.478,3.29,3.29V128.022z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#E4EBF0"
  },
  d: "M210.26,128.022c0,2.924,1.43,5.629,2.972,8.116l12.274,19.792 c1.305,2.108,4.762,4.029,7.249,4.029h26.996c1.815,0,3.29-1.478,3.29-3.29V124.32c0-1.812-1.475-3.29-3.29-3.29h-46.2 c-1.815,0-3.29,1.478-3.29,3.29V128.022z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 219.653,
  y: 201.447,
  style: {
    "fill": "#D0D7DC"
  },
  width: 24.361,
  height: 18.193
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#7C828D"
  },
  d: "M297.24,235.93l28.684,17.913V243.75c-2.075-43.654-49.959-46.21-77.276-46.359 c-2.561-0.014-4.633,2.047-4.633,4.609v17.135c0,2.529,2.072,4.565,4.601,4.599C280.573,224.162,292.725,229.132,297.24,235.93z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  style: {
    "fill": "#7C828D"
  },
  cx: 200.676,
  cy: 209.426,
  r: 31.257
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  style: {
    "fill": "#D0D7DC"
  },
  cx: 200.676,
  cy: 209.426,
  r: 16.177
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#29394A"
  },
  d: "M293.223,233.545l28.985,10.564c2.598,0.947,4.327,3.417,4.327,6.183v151.06h-39.496V237.873 C287.039,234.675,290.218,232.45,293.223,233.545z"
}))), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/5.4d92f942.svg";
export { SvgComponent as ReactComponent };